


































































import camelcaseKeysDeep from 'camelcase-keys-deep';
import Enterprise from '@/datatypes/enterprise';
import SubscriptionService from '@/services/billing/SubscriptionService';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import EnterpriseSubscriptionInfo from '@/components/billing/enterprise-subscription-info.vue';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import StripeCustomerDisplay from '@/components/stripe/customer/display.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    SnackbarMessageHandler,
    EnterpriseSubscriptionInfo,
    StripeCustomerDisplay,
  },
  data: () => ({
    enterprise: new Enterprise({}),
    errorMessage: '',
    enterpriseService: new EnterpriseService(),
    subscriptionService: new SubscriptionService(),
    isRemovingSubscription: false,
  }),

  mounted() {
    this.fetchEnterprise();
  },

  methods: {
    fetchEnterprise(): void {
      this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
        this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
      });
    },

    removeSubscription() {
      this.subscriptionService.remove(this.enterprise.id).then(() => {
        this.$router.push(`/businesses/${this.enterprise.id}/subscription`);
      });
    },
  },

  computed: {
    enterpriseId(): string {
      return this.$route.params.id;
    },
    canNewCustomer(): boolean {
      return this.enterprise.canNewCustomer();
    },
    hasSubscription(): boolean {
      return this.enterprise.hasSubscription();
    },
  },
});
